const FullScreen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 30.782 30.782"
    fill="inherit"
  >
    <path
      id="expand_1_"
      data-name="expand (1)"
      d="M6.012,0H24.77a6.024,6.024,0,0,1,6.012,6.012V24.77a6.024,6.024,0,0,1-6.012,6.012H6.012A6.024,6.024,0,0,1,0,24.77V6.012A6.024,6.024,0,0,1,6.012,0Zm.361,23.282A1.128,1.128,0,0,0,7.5,24.409h5.9a1.127,1.127,0,1,0,0-2.255H10.222l4.2-4.2a1.127,1.127,0,1,0-1.594-1.595l-4.2,4.2V17.382a1.127,1.127,0,1,0-2.255,0ZM24.409,7.5a1.128,1.128,0,0,0-1.127-1.127h-5.9a1.127,1.127,0,1,0,0,2.255h3.179l-4.2,4.2a1.128,1.128,0,0,0,1.595,1.595l4.2-4.2V13.4a1.127,1.127,0,1,0,2.255,0Z"
      fill="inherit"
      fill-rule="evenodd"
    />
  </svg>
);

export default FullScreen;
